import { ScheduleCellStatus } from '@main-application/boards/interfaces/board.enums';
import { CalendarStatus } from '@main-application/calendar/services/calendar-filtering.service';
import { RestInspectionsModel } from '@main-application/inspections/models/rest-inspections-model.interface';
import { RestTurnoverTaskModel } from '@shared/interfaces/turnover.interface';

export enum SpecialCalendarEvent {
  MoveIn = 'Move In',
  MoveOut = 'Move Out',
  Inspection = 'Inspection',
}

export class DayEvents {
  day: Date;
  list: CalendarBoardEvent[];
  showAll: boolean;
  counter: number;
}

export enum CalendarBoardEventType {
  MoveIn = 0,
  MoveOut = 1,
  Schedule = 2,
  Inspection = 3,
}

export class CalendarBoardEvent {
  eventType: CalendarBoardEventType;
  date: Date;
  dueDate?: Date;
  unitName: string;
  unitFinish: number;
  unitType: string;
  propertyName: string;
  turnoverId: number;
  url: string;
  colorScheme: number;
  sortOrder: number;
  draggable: boolean;
  status: ScheduleCellStatus;
  name: string;
  turnoverData: RestTurnoverTaskModel;
  id?: number;
  unitId?: number;
  propertyId?: number;
  assigneeName?: string;
  assigneeId?: number;
  email?: string;
  statusText?: CalendarStatus;
  boardId?: number;

  scheduleAppointmentIsRequired?: boolean;
  appointmentConfirmed?: boolean;
  appointmentDate?: Date;
  appointmentTime?: Date;
  appointmentNotes?: string;
}

export class InspectionCalendarBoardEvent extends CalendarBoardEvent {
  parent?: RestInspectionsModel;
}

export enum CalendarView {
  Week,
  Biweekly,
  Month,
}
